type RouteNavigationCandidate = {
  currentHref: string;
  destinationHref: string;
  target?: string | null;
  downloadsFile?: boolean;
  mouseButton?: number;
  hasModifierKey?: boolean;
};

export const shouldTrackRouteNavigation = ({
  currentHref,
  destinationHref,
  target,
  downloadsFile = false,
  mouseButton = 0,
  hasModifierKey = false,
}: RouteNavigationCandidate): boolean => {
  if (downloadsFile || hasModifierKey || mouseButton !== 0) return false;
  if (target && target.toLowerCase() !== "_self") return false;

  try {
    const currentUrl = new URL(currentHref);
    const destinationUrl = new URL(destinationHref, currentUrl);

    if (destinationUrl.origin !== currentUrl.origin) return false;

    return destinationUrl.href !== currentUrl.href;
  } catch {
    return false;
  }
};
